const EN = {
  ranges: { today: 'Today', '7d': '7 days', '30d': '30 days', all: 'All time' },
  status: {
    created: 'Requested', declined: 'Declined', approved: 'Accepted', arrived: 'On scene', started: 'In progress',
    paused: 'Paused', resumed: 'Resumed', scheduled: 'Scheduled', reviewed: 'Awaiting review',
    completed: 'Completed', expired: 'Expired', refunded: 'Refunded',
    cancelledByUser: 'Cancelled by customer', cancelledByPartner: 'Cancelled by provider',
    cancelledByAdmin: 'Cancelled by admin'
  },
  overview: 'Overview', dispatch: 'Dispatch', lead: 'Live operational state across the marketplace.',
  dateRange: 'Date range', export: 'Export', loadError: 'Could not load the dashboard.',
  revenue: 'Revenue', grossBookings: 'Gross bookings', versus: 'vs', previousPeriod: 'in the previous period',
  avgJobValue: 'Avg job value', completed: 'Completed', allTime: 'All time',
  fleetStatus: 'Fleet status', live: 'Live', onJob: 'On a job', idle: 'Idle', offline: 'Offline', online: 'ONLINE',
  bookings: 'Bookings', newCustomers: 'New customers', newProviders: 'New providers',
  jobPipeline: 'Job pipeline', now: 'now', activeNow: 'Active now', outcomes: 'Outcomes this period',
  medianAccept: 'Median accept', medianArrival: 'Median arrival', cancellationRate: 'Cancellation rate',
  needsAttention: 'Needs attention', openQueue: 'Open queue', dismiss: 'Dismiss', assign: 'Assign', open: 'Open',
  paidWaiting: 'Paid, waiting for a provider', stillOpen: 'Still open right now', newest: 'new',
  never: 'never', today: 'today', yesterday: 'yesterday',
  ago: n => `${n} days ago`,
  noCompleted: ago => `No completed jobs in this period. Last one ${ago}.`,
  lastBooking: ago => `Last booking ${ago}`,
  lastCompleted: ago => `Last completed ${ago}`,
  registered: n => `${n} registered`,
  nothingInFlight: ago => `Nothing in flight. Last booking ${ago}.`,
  noClosed: 'No jobs closed in this period.',
  nothingNeeds: ago => `Nothing needs attention. Last booking ${ago}.`,
  directPaid: (n, value) => `${value} direct booking${n === 1 ? '' : 's'} paid but unassigned.`,
  oldestWaiting: value => `Oldest has been waiting ${value}.`,
  directUnassigned: (n, value) => `${value} direct booking${n === 1 ? '' : 's'} unassigned`,
  oldest: value => `oldest ${value}`,
  jobsStatus: (n, value, status) => `${value} job${n === 1 ? '' : 's'} ${status.toLowerCase()}`,
  chartSummary: (value, count) => `${value} highest across ${count} points`,
  csv: {
    metric: 'Metric', value: 'Value', previous: 'Previous period', range: 'Range',
    commission: 'Platform commission', directUnassigned: 'Direct bookings unassigned', date: 'Date',
    gross: 'Gross', customers: 'New customers', providers: 'New providers'
  }
};

const AR = {
  ranges: { today: 'اليوم', '7d': '7 أيام', '30d': '30 يومًا', all: 'كل الوقت' },
  status: {
    created: 'مطلوب', declined: 'مرفوض', approved: 'مقبول', arrived: 'في الموقع', started: 'قيد التنفيذ',
    paused: 'متوقف مؤقتًا', resumed: 'مستأنف', scheduled: 'مجدول', reviewed: 'بانتظار المراجعة',
    completed: 'مكتمل', expired: 'منتهي', refunded: 'مسترد',
    cancelledByUser: 'ألغاه العميل', cancelledByPartner: 'ألغاه مقدم الخدمة',
    cancelledByAdmin: 'ألغاه المسؤول'
  },
  overview: 'نظرة عامة', dispatch: 'التوجيه', lead: 'الحالة التشغيلية المباشرة في جميع أنحاء المنصة.',
  dateRange: 'النطاق الزمني', export: 'تصدير', loadError: 'تعذر تحميل لوحة المعلومات.',
  revenue: 'الإيرادات', grossBookings: 'إجمالي الحجوزات', versus: 'مقابل', previousPeriod: 'في الفترة السابقة',
  avgJobValue: 'متوسط قيمة الوظيفة', completed: 'المكتملة', allTime: 'كل الوقت',
  fleetStatus: 'حالة الأسطول', live: 'مباشر', onJob: 'في مهمة', idle: 'متاح', offline: 'غير متصل', online: 'متصل',
  bookings: 'الحجوزات', newCustomers: 'عملاء جدد', newProviders: 'مقدمو خدمة جدد',
  jobPipeline: 'مراحل الوظائف', now: 'الآن', activeNow: 'نشطة الآن', outcomes: 'نتائج هذه الفترة',
  medianAccept: 'الوسيط لوقت القبول', medianArrival: 'الوسيط لوقت الوصول', cancellationRate: 'معدل الإلغاء',
  needsAttention: 'يحتاج إلى متابعة', openQueue: 'فتح قائمة الانتظار', dismiss: 'إخفاء', assign: 'تعيين', open: 'فتح',
  paidWaiting: 'مدفوع، بانتظار مقدم خدمة', stillOpen: 'لا تزال مفتوحة الآن', newest: 'جديد',
  never: 'لم يحدث قط', today: 'اليوم', yesterday: 'أمس',
  ago: n => `منذ ${n} أيام`,
  noCompleted: ago => `لا توجد وظائف مكتملة في هذه الفترة. آخر وظيفة ${ago}.`,
  lastBooking: ago => `آخر حجز ${ago}`,
  lastCompleted: ago => `آخر حجز مكتمل ${ago}`,
  registered: n => `${n} مسجلون`,
  nothingInFlight: ago => `لا توجد وظائف قيد التنفيذ. آخر حجز ${ago}.`,
  noClosed: 'لا توجد وظائف مغلقة في هذه الفترة.',
  nothingNeeds: ago => `لا شيء يحتاج إلى متابعة. آخر حجز ${ago}.`,
  directPaid: (n, value) => `${value} ${n === 1 ? 'حجز مباشر مدفوع وغير معيّن.' : 'حجوزات مباشرة مدفوعة وغير معيّنة.'}`,
  oldestWaiting: value => `الأقدم ينتظر منذ ${value}.`,
  directUnassigned: (n, value) => `${value} ${n === 1 ? 'حجز مباشر غير معيّن' : 'حجوزات مباشرة غير معيّنة'}`,
  oldest: value => `الأقدم ${value}`,
  jobsStatus: (n, value, status) => `${value} ${n === 1 ? 'وظيفة' : 'وظائف'} ${status}`,
  chartSummary: (value, count) => `أعلى قيمة ${value} عبر ${count} نقاط`,
  csv: {
    metric: 'المقياس', value: 'القيمة', previous: 'الفترة السابقة', range: 'النطاق',
    commission: 'عمولة المنصة', directUnassigned: 'الحجوزات المباشرة غير المعيّنة', date: 'التاريخ',
    gross: 'الإجمالي', customers: 'عملاء جدد', providers: 'مقدمو خدمة جدد'
  }
};

export const isArabic = locale => locale === 'ar';
export const dispatchCopy = locale => isArabic(locale) ? AR : EN;
export const dispatchNumber = (value, locale, options) => Number(value || 0)
  .toLocaleString(isArabic(locale) ? 'ar-AE' : 'en-GB', options);

export const dispatchDuration = (secs, locale) => {
  if (secs === null || secs === undefined) return '—';
  const ar = isArabic(locale);
  if (secs < 60) return `${dispatchNumber(secs, locale)}${ar ? 'ث' : 's'}`;
  if (secs < 3600) return `${dispatchNumber(Math.round(secs / 60), locale)}${ar ? 'د' : 'm'}`;
  if (secs < 86400) return `${dispatchNumber(secs / 3600, locale, { maximumFractionDigits: 1 })}${ar ? 'س' : 'h'}`;
  return `${dispatchNumber(Math.round(secs / 86400), locale)}${ar ? 'ي' : 'd'}`;
};

export const dispatchAgo = (days, locale) => {
  const t = dispatchCopy(locale);
  if (days === null || days === undefined) return t.never;
  if (days === 0) return t.today;
  if (days === 1) return t.yesterday;
  return t.ago(dispatchNumber(days, locale));
};
